import { useState } from 'react'
import { Popover } from '@mui/material'
import { useSelector } from 'react-redux'

import './infoUser.css'
import { GestionarCuenta } from './GestionarCuenta'
import { CerrarSesion } from './CerrarSesion'

export const InfoUser = () => {

    const { name } = useSelector(state => state.auth)
    const { nombre_comercial } = useSelector(state => state.general.info)
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div>

            <button
                className='btn text-sm flex items-center focus:ring-0'
                onClick={handleClick}
            >
                <span className='hidden md:block'>{name}</span>
                <span className='w-7 h-7 rounded-full bg-[--primary-color] text-white md:ms-2 items-center flex justify-center text-sm'>
                    {name.substring(0, 1).toUpperCase()}
                </span>
            </button>

            <Popover
                className='p-popover-info-user'
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}

                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >

                <div className='p-popover-content-info-user'>
                    <div className="row row-cols-1">
                        <div className="col text-center">
                            {/* <div className="text-center m-3">
                                <img src={image} className="rounded-circle p-popover-img-info-user" alt="..." />
                                <div className='p-icon-camera text-center'>
                                    <IconButton className='p-icon-button' color="primary" aria-label="upload picture" component="label">
                                        <input hidden accept="image/*" type="file" />
                                        <LocalSeeOutlinedIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div> */}
                            <h5 style={{ textTransform: 'capitalize', marginTop: '20px' }}>Hola, {name}</h5>
                            <h6>({nombre_comercial})</h6>
                        </div>
                        <div className="col text-center border">
                            <GestionarCuenta />
                        </div>
                        {/* <div className="col text-center ">
                            <OtraCuenta />
                        </div> */}
                        <div className="col text-center border mb-3">
                            <CerrarSesion />
                        </div>
                    </div>
                </div>
            </Popover>
        </div>
    )
}
